import { Team } from "../../models/teamModel";
import { DescriptionTerm } from "../catalyst/description-list";
import { Text } from "../catalyst/text";
import { PlayerRecord } from "../PlayerRecord";
import { classNames } from "../../utils/appUtils";


export const ShortlistPlayersViewer: React.FC<{ team: Team }> = ({ team }) => {
  const { shortlistedPlayersColl } = team;

  return (
    <div>
      <DescriptionTerm>
        Shortlisted Players: {shortlistedPlayersColl.length}
      </DescriptionTerm>

      {shortlistedPlayersColl &&
        shortlistedPlayersColl.map((player, index) => (
          <div
            key={player.playerId}
            className={classNames(
              "flex gap-2 items-center px-2 rounded py-1",
              index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : ""
            )}
          >
            <Text className="text-sm font-semibold">{index + 1}.</Text>
            <PlayerRecord member={player} />
          </div>
        ))}
    </div>
  );
};
